import { Loader } from "@mantine/core";
import { message } from "antd";
import _ from "lodash";
import { RequiredIndicator } from "../../../components";
import { useQuery, useMutation } from "react-query";
import {
  getNursingNoteById,
  postNursingNote,
  putNursingNote,
} from "../../../helpers/api";
import { useAtom } from "jotai";
import { nursingNoteAtom, clearNursingNoteAtom } from "../../../helpers/state";
import { useEffect } from "react";

const EditNursingNote = ({
  nursingNoteId,
  isNewNote = false,
  onRefresh,
  consultationId,
  onPost,
}) => {
  const [state, setState] = useAtom(nursingNoteAtom);
  const [, clearNote] = useAtom(clearNursingNoteAtom);

  const { isError, isFetching } = useQuery({
    queryFn: () => getNursingNoteById(nursingNoteId),
    queryKey: ["nursing-note", nursingNoteId],
    onSuccess: (data) => setState(data),
    enabled: !isNewNote,
  });

  const { mutateAsync: updateNursingNote, isLoading } = useMutation(
    (data) => putNursingNote(data),
    {
      onSuccess: (data, variables, context) => {
        if (data.status === 200) {
          message.success(data.data.message);
          onRefresh();
          return;
        }
        throw data;
      },
      onError: (error, variables, context) => {
        const err = error?.response?.data?.message;
        if (_.isArray(err)) {
          err.map((err) => message.error(err.message));
        } else {
          message.error(err);
        }
      },
    }
  );

  const { mutateAsync: createNursingNote, isLoading: creatingNote } =
    useMutation((data) => postNursingNote({ ...data, consultationId }), {
      onSuccess: (data, variables, context) => {
        if (data.status === 201) {
          message.success(data.data.message);
          onRefresh();
          setState({});
          onPost();
          return;
        }
        throw data;
      },
      onError: (error, variables, context) => {
        const err = error.response.data.message;
        if (_.isArray(err)) {
          err.map((err) => message.error(err.message));
        } else {
          message.error(err);
        }
      },
    });

  useEffect(() => {
    return () => !isNewNote && clearNote();
  }, []);

  return (
    <>
      {isFetching ? (
        <div className="text-center">
          <Loader /> please wait...
        </div>
      ) : (
        <>
          <div className="row mb-1">
            <div className="field">
              <label className="mb-0" htmlFor="notes">
                Nursing Notes
                <RequiredIndicator />
              </label>
              <textarea
                className="textarea"
                rows={8}
                value={state.notes}
                onChange={(e) => setState({ ...state, notes: e.target.value })}
                id="notes"
                placeholder="Enter nursing notes, observations, and care provided..."></textarea>
            </div>
          </div>

          {isNewNote ? (
            <button
              onClick={() => createNursingNote(state)}
              id="submit"
              className={`button h6 app-btn btn-prim mt-3 ${
                creatingNote && " is-loading "
              }`}>
              <span className="bi bi-plus-circle me-2" />
              Save Note
            </button>
          ) : (
            <button
              onClick={() => updateNursingNote(state)}
              id="submit"
              className={`button h6 app-btn btn-prim mt-3 ${
                isLoading && " is-loading "
              }`}>
              <span className="bi bi-save me-2" />
              Update Note
            </button>
          )}
        </>
      )}
    </>
  );
};

export default EditNursingNote;
